import React, {useEffect, useState} from 'react';
import logo from '../../assets/Images/revenuintel.jpg';
import './Header.css';
import { RiLogoutCircleLine } from "react-icons/ri";
import { MdAccountBalanceWallet } from "react-icons/md";
import { MdOutlineSearch } from "react-icons/md";
import Swal from "sweetalert2";
import {useNavigate, useLocation} from 'react-router-dom';
import { MdHome } from "react-icons/md";

const Header = ({setSearchData, credits, setCredits, spentCredits, setSpentCredits, remainingCredits, setRemainingCredits, isContacts, setIsContacts, isMyContacts, userlists}) => {

  const location = useLocation();
    const baseURL = 
    process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_API_URL_PROD 
    : process.env.REACT_APP_API_URL_LOCAL;

    const navigate = useNavigate();
    const [role, setRole] = useState('');

    useEffect(()=>{
      const userRole = localStorage.getItem('role');
      setRole(userRole);
      if(role === 'user' ){
      fetchUsers();
      }
    },[])

    const fetchUsers = async () => {
      const token = localStorage.getItem("token");
      
      if (!token) {
        console.error("No token found. User is not authenticated.");
      return;
      }
      
      const apiUrl = `${baseURL}/api/user`;
      try {
        const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch user data (Status: ${response.status})`);
      }
      
      const data = await response.json();
      
      if (!data || typeof data !== 'object') {
        throw new Error("Unexpected response format: Expected an object");
      }
      
      if (data.details && Array.isArray(data.details)) {
        setCredits(data.subscriptions[0].credits);
        setSpentCredits(data.subscriptions[0].spentcredits);
        setRemainingCredits(data.subscriptions[0].remainingcredits);
      } else {
        console.error("details is missing or not an array");
      }
      
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Internal Server Error",
          text: error.message || "Error fetching user details",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
      }
  };

 const handleAccount = () =>{
      navigate('/dashboard');
    }
    
    const handleSearchChange = (e) => {
      setSearchData(e.target.value ? e.target.value.toLowerCase() : ""); 
    };

  const handleLogout = () => {
  Swal.fire({
    icon: "warning",
    title: "Are you sure you want to logout?",
    showCancelButton: true,
    confirmButtonColor: "#FCB124",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        await fetch( `${baseURL}/api/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        localStorage.clear();
        window.location.href = "/";
      } catch (error) {
        console.error("Logout failed:", error);
        Swal.fire("Error", "Logout failed. Try again.", "error");
      }
    }
  });
};

  return (
    <>
        <header 
         style={role === 'user'? {gap: '160px'}: {gap: '350px'}}
        >
            <div className='header-container'>
                <div className='header-logo' onClick={()=>navigate('/dashboard')}>
                    <img src={logo} alt='octonius-logo'/>
                </div>
            </div>
            <div className='header-container'>
              <div className='crm-search'>
                <input className="header-search"
                        placeholder="Search..."
                        onChange={handleSearchChange}/>
                      <MdOutlineSearch className='search-icon3'/>
                      </div>
                      </div>
                      <div style={{display:'flex', flexDirection:'row', gap:'40px'}}>
                    <div className='header-container' style={{display:'flex', flexDirection:'row', gap:'40%', alignItems:'center'}}>
                      {role === 'user' &&(
                     <div
                      style={{width:'200px', visibility: location.pathname.startsWith('/companypage')|| location.pathname.startsWith('/contacts') ? 'hidden' : 'visible' }}
                        >
                        <div className='people-dwld'>
                          <div className='balance-svg' style={{display: 'flex', flexDirection: 'row', justifyContent:'left', alignItems:'center', gap:'5px'}}>
                            <MdAccountBalanceWallet /><p>Balance</p>
                          </div>
                          <div className='add-credits'>
                          <p style={{fontSize: '10px', color: '#aaa'}}>TOTAL</p>
                          &nbsp;
                          <h6 style={{fontSize: '10px', color: '#000'}}>{credits}</h6>
                          </div>
                          <div className='add-credits'>
                          <p style={{fontSize: '10px', color: '#aaa'}}>SPENT</p>
                          &nbsp;
                          <h6 style={{fontSize: '10px', color: '#000'}}>{spentCredits}</h6>
                          </div>
                          <div className='add-credits'>
                          <p style={{fontSize: '10px', color: '#aaa'}}>REMAINING</p>
                          &nbsp;
                          <h6 style={{fontSize: '10px', color: '#000'}}>{remainingCredits}</h6>
                          </div>
                        </div>
                  </div>)}
                <div style={{cursor:'pointer'}} onClick={handleAccount}>
                    <p><MdHome style={{color:'#FCB124', fontSize:'24px'}}/></p>
                </div>
                <div  onClick={handleLogout}  style={{cursor:'pointer', display:'flex', flexDirection:'row', gap:'3px', justifyContent:'center', alignItems:'center'}}>
                  <RiLogoutCircleLine style={{fontSize:'20px',color:'#FCB124', cursor:'pointer'}}/>
                    <p style={{fontSize:'14px', fontWeight:'bold'}}> Logout</p>
                    </div></div>
            </div>
        </header>


    </>
  )
}

export default Header;